/**
 * Checks whether a backend-gated app callout may be shown.
 *
 * Callouts without a required feature flag remain visible. When the backend
 * supplies a flag key, the client requires an explicit enabled value so unknown
 * or not-yet-loaded flags fail closed.
 */
export const isAppCalloutFeatureFlagRequirementSatisfied = ({
  getFlagStatus,
  requiredFeatureFlag,
}: {
  getFlagStatus: (flag: string) => boolean | undefined;
  requiredFeatureFlag: string | null | undefined;
}): boolean => {
  if (!requiredFeatureFlag) {
    return true;
  }

  return getFlagStatus(requiredFeatureFlag) === true;
};
